import { Space, SpaceProps } from 'antd';
import React from 'react';
import styled from 'styled-components';

const StyledTableActionsCellSpace = styled(Space)`
  margin-top: -10px;
  margin-bottom: -10px;
`;

export interface ITableActionsCellSpaceProps extends SpaceProps {}

/**
 * Wrapper per le azioni della tabella.
 *
 * Permette il distanziamento tra i bottoni e riduce l'ingombro verticale.
 */
export function TableActionsCellSpace(props: ITableActionsCellSpaceProps) {
  return <StyledTableActionsCellSpace size={0} {...props} />;
}
